import { params, executeSearchUrl, displayResults } from '../search-main';
import { URLCriteriaHelper } from '../search-urlcriteriahelper';
let sortField: HTMLSelectElement | null;
let sortDirection: HTMLSelectElement | null;
let sortContainer: HTMLDivElement | null;
let sortDirectionContainer: HTMLDivElement | null;

document.addEventListener('DOMContentLoaded', () => {
    sortField = document.querySelector<HTMLSelectElement>('#sort-item');
    sortDirection = document.querySelector<HTMLSelectElement>('#sort-direction');
    sortContainer = document.querySelector<HTMLDivElement>('#sort-filter-container');
    sortDirectionContainer = document.querySelector<HTMLDivElement>('#sort-direction-container');

    sortField?.addEventListener('change', sortFieldChanged)
    sortDirection?.addEventListener('change', sortDirectionChanged);
});

/**
 * Sets the values for the SortField and SortDirection selects
 * as well as shows or hides the component
 * @constructor
 * @param {boolean} show - Indicates whether to show or hide sort container
 */
export function displaySortFilter(show: boolean = true) {
    if (!sortContainer || !sortField || !sortDirection) { return; }

    if (params.SortField) {
        sortField.value = params.SortField;
        if (params.SortDirection) {
            sortDirection.value = params.SortDirection;
        }
    }

    if (show) {
        sortContainer.classList.remove("!hidden");
        displayDirectionFilter();
    }
    else {
        sortContainer.classList.add("!hidden");
    }
}

function displayDirectionFilter() {
    if (!sortContainer || !sortDirectionContainer || !sortField || !params.SortField) { return; }
    
    if (params.SortField !== "relevance") {
        toggleDirectionContainer(true);
    } else if (!sortDirectionContainer.classList.contains("hidden")) {
        toggleDirectionContainer(false);
    }
}

function sortFieldChanged() {
    if (!sortField || !sortDirectionContainer || !sortDirection) { return; }

    if (sortField.value === "relevance") {
        toggleDirectionContainer(false);
        sortDirection.value = "desc";
    } else {
        if (sortDirectionContainer.classList.contains("hidden")) {
            toggleDirectionContainer(true);
        }
        sortDirection.value = "asc";
    }

    params.Page = "1";
    params.SortField = sortField.value;
    params.SortDirection = sortDirection.value;
    displayDirectionFilter();
    displayResults(executeSearchUrl);
    URLCriteriaHelper.reconstructUrl();
}

function toggleDirectionContainer(show: boolean) {
    if (!sortDirectionContainer) { return; }

    if (show) {
        sortDirectionContainer.classList.add("md:inline-flex");
        sortDirectionContainer.classList.remove("hidden");
    } else {
        sortDirectionContainer.classList.add("hidden");
        sortDirectionContainer.classList.remove("md:inline-flex");
    }
}

function sortDirectionChanged() {
    if (!sortDirection) { return; }

    params.Page = "1";
    params.SortDirection = sortDirection.value;
    displayResults(executeSearchUrl);
    URLCriteriaHelper.reconstructUrl();
}
